module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAApklEQVR4Ae3RsQ3CMBRF0QsbUIDkPemhzwo0MAKIfWgSUZAJAExL97Cforj499X+pzBRkyUuPMhiOypb0ZP/2paqDuKsTdzIcnuHeGoA6ARhA5qwAU1YgEG8CgBN2IAmDEATBmAQ7wrgl5gIgM4E9JoBPnMDAZQ+mAYIwJgPBLAwP9kHAliSvQWgJxus8z2ykwUckW24V58fWKMjcWUsPj5yJhE12BdFt+xHHVs5ogAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Entityselector/baseline_description_black_24dp.png
// module id = 107
// module chunks = 0